import {useState} from 'react'
// import {toast} from 'react-toastify'
// import Spinner from 'layout/common/Spinner'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {KTSVG} from 'helpers'
import {IItmesConfig} from 'models/GenericForm'
import OnBoardingFormComponent from './OnBoardingFormComponent'
import {IFormField} from 'models/Common'
// import {ILogin} from 'models/Auth'

type IProps = {
 userId: string
 parentItemConfig?: IItmesConfig
 loader: boolean
 accessDetails: IFormField
 setLoader: (newState: boolean) => void
 reloadTabs: () => void
}

const CompanyProfile = (props: IProps) => {
 const {t} = useTranslation()
 const [isDisabled, setIsDisabled] = useState(true)

 const handleEditBtnClick = () => {
  if (props.accessDetails?.basicDetails?.canEdit)
   setIsDisabled(false)
 }

 return (
  <div className='w-full'>
   {isDisabled && (
    <div className='w-full mb-3 flex justify-end'>
     <div className='flex items-center '>
      <Button
       disabled={
        !props.accessDetails?.basicDetails?.canEdit
       }
       onClick={handleEditBtnClick}
       color='blue'
       className='text-center py-[9px] pr-6 pl-4 bg-white 
                     !rounded-lg text-base !text-[#4E83E4] font-semibold border-[#4E83E4]'
      >
       <KTSVG
        path={`/media/icons/pencil.svg`}
        svgClassName={`w-4 h-4 text-white p-[2px]`}
       />
       {t('myAccountPage.edit')}
      </Button>
     </div>
    </div>
   )}
   <OnBoardingFormComponent
    userId={props.userId}
    setIsDisabled={setIsDisabled}
    reloadTabs={props.reloadTabs}
    parentItemConfig={props.parentItemConfig}
    loader={props.loader}
    isDisabled={isDisabled}
    setLoader={props.setLoader}
    className='grid md:grid-cols-3 gap-5 w-full mt-4'
   />
  </div>
 )
}

export default CompanyProfile
